/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import { Consumer as CommunityContextConsumer } from '../../../contexts/CommunityContext';

import { getFormattedTimestamp } from '../../Utilities/TimeFunctions';
import CommentComponent from '../CommentComponent/CommentComponent';

import CommentInput from '../CommentInput/CommentInput';

import './CommentList.scss';

export const getFormattedLastEdit = (lastEditDate, action) => {
    return `User ${action} comment on ${getFormattedTimestamp(lastEditDate)}`;
};

/**
 * @deprecated
 */
export default class CommentList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            newComments: [],
        };
    }

    static propTypes = {
        /**
         * comemnts
         */
        comments: PropTypes.array,
        /**
         * hash of comment that is open
         */
        openedCommentHash: PropTypes.string,
        /**
         * function to open comment box
         */
        openedCommentBox: PropTypes.func,
        /**
         * whether on feed or not
         */
        onFeed: PropTypes.bool,
        hideReactionBar: PropTypes.bool,
        MoreCommentsFunction: PropTypes.func,
        isInMasterFeed: PropTypes.bool,
        parentUrl: PropTypes.string,
    };

    static defaultProps = {
        openedCommentHash: null,
        onFeed: true,
        hideReactionBar: false,
        MoreCommentsFunction: () => {},
    };

    getInputComponent = (hash, indent) => {
        let commentWidget = null;
        const stopIndent = indent >= 2 ? 2 : indent;
        const newComments = this.state.newComments;
        if (hash === this.props.openedCommentHash) {
            commentWidget = (
                <CommunityContextConsumer>
                    {(context) =>
                        this.prepareIndentation(
                            <CommentInput
                                placeholderText={'Your reply ...'}
                                key={hash}
                                parentHash={hash}
                                onSubmit={(hash, comment, isAnon) => {
                                    newComments.push(hash);
                                    this.setState(
                                        {
                                            newComments,
                                        },
                                        () =>
                                            context.submitComment(
                                                hash,
                                                comment,
                                                isAnon
                                            )
                                    );
                                }}
                            />,
                            stopIndent,
                            hash
                        )
                    }
                </CommunityContextConsumer>
            );
        }
        return commentWidget;
    };

    renderDeletedTimestamp = (comment, position, lastEditDate) => (
        <div
            className="moderated-comment-timestamp deleted-timestamp"
            key={`comment_${position}_${comment.hash}`}
        >
            {getFormattedLastEdit(lastEditDate, 'deleted')}
        </div>
    );

    renderCommentComponent = (comment, position, mode, indentation) => {
        const isFirstComment = indentation === 1;
        return (
            <div
                href={comment.href}
                className={`comment comment_${position}_${comment.hash}`}
                name={`comment_${position}_${comment.hash}`}
                key={`comment_${position}_${comment.hash}`}
            >
                <CommentComponent
                    location="CommentList"
                    comment={comment}
                    mode={mode}
                    parentUrl={this.props.parentUrl}
                    isInMasterFeed={this.props.isInMasterFeed}
                    isFirstComment={isFirstComment}
                    hideReactionBar={this.props.hideReactionBar}
                />
            </div>
        );
    };

    renderComment = (comment, mode, indexer, indentation) => {
        let position = indexer.index;
        indexer.index = indexer.index += 1;

        const { type, lastEditDate } =
            (comment.moderationOption && comment.moderationOption.status) || {};
        const isCommentDeleted = type === 'delete';
        const Component = (
            <div
                className={'comment-container comment-primary-container'}
                key={comment.hash}
            >
                {isCommentDeleted
                    ? this.renderDeletedTimestamp(
                          comment,
                          position,
                          lastEditDate
                      )
                    : this.renderCommentComponent(
                          comment,
                          position,
                          mode,
                          indentation
                      )}
            </div>
        );

        return this.prepareIndentation(Component, indentation, comment.hash);
    };

    renderMoreCommentsButton = (comment, moreCommentCount) => {
        const replyText = moreCommentCount === 1 ? 'reply' : 'replies';
        return (
            <button
                className={'more-comments-button'}
                onClick={() => this.props.MoreCommentsFunction(comment)}
            >{`See ${moreCommentCount} other ${replyText}`}</button>
        );
    };

    prepareIndentation = (Component, indentation, hash) => {
        if (indentation < 1) {
            return [Component];
        }
        return [
            <div className={'indented'} key={`comment_indentation_${hash}`}>
                {this.prepareIndentation(
                    Component,
                    Number(indentation) - 1,
                    hash
                )}
            </div>,
        ];
    };

    renderComments = (comments, indent, indexer) => {
        return (
            <div>
                {comments &&
                    comments.map((comment) => {
                        const moreCommentCount =
                            indent === 3 ? comment.getTotalCount() : 0;
                        return (
                            <div key={'top-' + comment.hash}>
                                {(!(indent > 3) ||
                                    comment.isNew ||
                                    this.state.newComments.includes(
                                        comment.hash
                                    )) &&
                                    this.renderComment(
                                        comment,
                                        'full',
                                        indexer,
                                        indent
                                    )}
                                {this.getInputComponent(
                                    comment.hash,
                                    indent + 1
                                )}
                                {this.renderComments(
                                    comment.comments,
                                    indent + 1,
                                    indexer
                                )}
                                {indent >= 3 &&
                                moreCommentCount &&
                                !comment.isNew &&
                                !this.props.onFeed
                                    ? this.renderMoreCommentsButton(
                                          comment,
                                          moreCommentCount
                                      )
                                    : null}
                            </div>
                        );
                    })}
            </div>
        );
    };

    render() {
        let indexer = { index: 1 };
        const initialIndent = this.props.onFeed ? 1 : 0;
        return (
            <div className="component-Community-CommentList">
                {this.renderComments(
                    this.props.comments,
                    initialIndent,
                    indexer
                )}
            </div>
        );
    }
}
